// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__5Gmcp","head":"Table_head__tSJnU","col":"Table_col__3GnGN"};